import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteemitComponent } from './simple-icons-steemit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteemitComponent ],
    exports:      [ SimpleIconsSteemitComponent ],
    bootstrap:    []
})
export class SimpleIconsSteemitModule {}
